import styled from "@emotion/styled";

export const ContactWrapper = styled.div`
  margin: 5rem 0;
`;

export const Email = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-around;
  flex-wrap: wrap;
  row-gap: 1rem;
  background: white;
  padding: 1rem;
  border-radius: 4rem;
  

  span {
    font-size: 1rem;
    font-weight: 400;
    color: black;
  }

  @media (min-width: 576px) {
    span {
      font-size: 1.25rem;
      background-repeat: no-repeat;

    }
  }
  @media (min-width: 992px) {
    span {
      font-size: 1.5rem;
      background-repeat: no-repeat;

    }
  }
`;
